import { formatObjToParamStr, getUrlParams, setCookie, isWechatMiniProgramBrowser, isAlipayMiniProgramBrowser } from './common-helper';
import { NEW_MINI_PROGRAM_NAME_KEY, NEW_MINI_PROGRAM_NAME_VALUE } from '../helper/const';

const wxminiProgramHelper = {
  _jssdkUrl: 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js',

  _init() {
    if (!this.isMiniProgramMode() || !this.isNewMiniprogram()) {
      return Promise.reject(new Error('not in wxmini'));
    }

    if (this.inited) {
      return Promise.resolve(window.wx);
    }

    return new Promise((resolve, _reject) => {
      let script = document.createElement('script');

      // other version js loaded;
      delete window.wx;
      delete window.jWeixin;

      script.onload = () => {
        this.inited = true;
        resolve(window.wx);
      };

      script.src = this._jssdkUrl;
      document.body.appendChild(script);
      script = null;
    });
  },

  isMiniProgramMode() {
    return isWechatMiniProgramBrowser();
  },

  isNewMiniprogram() {
    return sessionStorage.getItem(NEW_MINI_PROGRAM_NAME_KEY) === NEW_MINI_PROGRAM_NAME_VALUE;
  },

  call(method, ...args) {
    this._init()
      .then(wx => {
        if (!wx || !wx.miniProgram) {
          throw new Error('wx jssdk unload');
        }

        const fn = wx.miniProgram[method];
        if (!fn) {
          throw new Error(`miniProgram do not contains the method of ${method}`);
        }

        return fn.apply(wx.miniProgram, args);
      })
      .catch(e => {
        console.warn(e.message);
      });
  },

  navigateTo(url, params) {
    this.route('navigateTo', url, params);
  },

  redirectTo(url, params) {
    this.route('redirectTo', url, params);
  },

  route(method, url, params) {
    const nextUrl = `${url}?${formatObjToParamStr(params)}`;

    this.call(method, { url: nextUrl });
  },
};

function saveMidToCookie() {
  const { mid, brandId } = getUrlParams();

  if (brandId) {
    sessionStorage.setItem('currentBrandId', brandId);
  }

  if (!mid || !brandId) {
    return;
  }

  setCookie(`mid_${brandId}`, mid);
}

function saveMiniProgramName() {
  const params = getUrlParams();
  const miniProgramName = params[NEW_MINI_PROGRAM_NAME_KEY];

  if (miniProgramName) {
    sessionStorage.setItem(NEW_MINI_PROGRAM_NAME_KEY, miniProgramName);
  }
}

function saveAliUserId() {
  const { userid } = getUrlParams();
  if (userid) {
    localStorage.setItem('userid', userid);
  }
}

export function runInRootWhenMiniPrograme() {
  if (isAlipayMiniProgramBrowser()) {
    // 将支付宝 userid存入localStorage
    saveAliUserId();
    saveMidToCookie();
    return;
  }
  if (!wxminiProgramHelper.isMiniProgramMode()) {
    return;
  }

  saveMidToCookie();
  saveMiniProgramName();
}

export default wxminiProgramHelper;



// WEBPACK FOOTER //
// ./src/helper/wx-miniprogram-helper.js